import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { CartComponent } from './cart.component';
import { PipesCoreModule } from '../../../../core/pipes/pipes-core.module';
import { ProductOrderByPipe } from './utils/pipes/product-order-by.pipe';
import { CalcularPipe } from './utils/pipes/calcular.pipe';
import { ListProductCartComponent } from './list-product-cart/list-product-cart.component';
import { KBotonDirective } from './utils/directives/kboton.directive';
import { MatIconModule } from '@angular/material/icon';
import { EncryptPipe } from './utils/pipes/encrypt.pipe';
import { RouterModule } from '@angular/router';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SucursalPredeterminadaPipe } from './utils/pipes/sucursal-predeterminada.pipe';
import { PrecioPipe } from './utils/pipes/precio.pipe';
import { CalculoKabicoinPipe } from './utils/pipes/calculo-kabicoin.pipe';
import { CantidadSelectComponent } from './list-product-cart/cantidad-select/cantidad-select.component';
import { RouterSolutionsBrandsPipe } from './utils/pipes/router-solutions-brands.pipe';
import { CleanClavePipe } from './utils/pipes/clean-clave.pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IConfig, NgxMaskModule } from 'ngx-mask';
import { DialogConfirmComponent } from './dialog-confirm/dialog-confirm.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TipoCompraComponent } from './components/tipo-compra/tipo-compra.component';
import { MatRadioModule } from '@angular/material/radio';
import { BrowserModule } from '@angular/platform-browser';
import { MetodoPagoComponent } from './components/metodo-pago/metodo-pago.component';
import { ListFacturasComponent } from './components/dialogs/list-facturas/list-facturas.component';
import { FormFacturaComponent } from './components/dialogs/form-factura/form-factura.component';
import { LabelCheckComponent } from './components/dialogs/label-check/label-check.component';
import { BooleanPipe } from './utils/pipes/boolean.pipe';
import { UsoCfdiComponent } from './components/uso-cfdi/uso-cfdi.component';
import { MetodoEntregaSucursalComponent } from './components/metodo-entrega-sucursal/metodo-entrega-sucursal.component';
import { AddressSucursalComponent } from './components/metodo-entrega-sucursal/address-sucursal/address-sucursal.component';
import { FormAddressComponent } from './components/dialogs/form-address/form-address.component';
import { PhoneFormatPipe } from './utils/pipes/phone-format.pipe';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MetodoEntregaCedisComponent } from './components/metodo-entrega-cedis/metodo-entrega-cedis.component';
import { AddressCedisComponent } from './components/metodo-entrega-cedis/address-cedis/address-cedis.component';
import { SaveLaterComponent } from './components/save-later/save-later.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ResumenComponent } from './components/resumen/resumen.component';
import { MatDividerModule } from '@angular/material/divider';
import { SpanLegendComponent } from './components/span-legend/span-legend.component';
import { BotonOrderComponent } from './components/boton-order/boton-order.component';
import { TipoImpuestoPPipe } from './utils/pipes/tipo-impuesto-p.pipe';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { EfectivoComponent } from './components/boton-order/pagos/efectivo/efectivo.component';
import { BotonGeneralComponent } from './components/boton-general/boton-general.component';
import { MatRippleModule } from '@angular/material/core';
import { PaypalComponent } from './components/boton-order/pagos/paypal/paypal.component';
import { ResumenResponsiveComponent } from './components/resumen-responsive/resumen-responsive.component';
import { SearchModalComponent } from './search-modal/search-modal.component';
import { CantidadSelectMultiComponent } from './search-modal/cantidad-select-multi/cantidad-select-multi.component';
import { ItemProductoComponent } from './search-modal/item-producto/item-producto.component';
import { CrearArrayPipe } from './utils/pipes/crear-array.pipe';
import { PedidoGeneradoComponent } from './pedido-generado/pedido-generado.component';
import { MatSelectModule } from '@angular/material/select';
import { MatExpansionModule } from '@angular/material/expansion';
import { SearchInputComponent } from './search-modal/search-input/search-input.component';
import { AutocompletePipe } from './utils/pipes/autocomplete.pipe';
import { MatListModule } from '@angular/material/list';
import { ListaCategoriasComponent } from './search-modal/search-input/lista-categorias/lista-categorias.component';
import { ListaMarcasComponent } from './search-modal/search-input/lista-marcas/lista-marcas.component'; 
import { NgxPayPalModule } from 'ngx-paypal';
import { ImgErrorHandlerDirective } from './utils/directives/img-error-handler.directive';
import { RemoveTextPipe } from './utils/pipes/remove-text.pipe';

const optionsMask: Partial<IConfig> | (() => Partial<IConfig>) = {};

@NgModule({
  declarations: [
    CartComponent,
    ListProductCartComponent,
    CantidadSelectComponent,
    DialogConfirmComponent,
    TipoCompraComponent,
    MetodoPagoComponent,
    ListFacturasComponent,
    FormFacturaComponent,
    LabelCheckComponent,
    UsoCfdiComponent,
    MetodoEntregaSucursalComponent,
    AddressSucursalComponent,
    FormAddressComponent,
    MetodoEntregaCedisComponent,
    AddressCedisComponent,
    SaveLaterComponent,
    ResumenComponent,
    SpanLegendComponent,
    BotonOrderComponent,
    ProductOrderByPipe,
    CalcularPipe,
    EncryptPipe,
    SucursalPredeterminadaPipe,
    PrecioPipe,
    CalculoKabicoinPipe,
    RouterSolutionsBrandsPipe,
    CleanClavePipe,
    BooleanPipe,
    KBotonDirective,
    PhoneFormatPipe,
    TipoImpuestoPPipe,
    EfectivoComponent,
    BotonGeneralComponent,
    PaypalComponent,
    ResumenResponsiveComponent,
    SearchModalComponent,
    CantidadSelectMultiComponent,
    ItemProductoComponent,
    CrearArrayPipe,
    PedidoGeneradoComponent,
    SearchInputComponent,
    AutocompletePipe,
    ListaCategoriasComponent,
    ListaMarcasComponent,
    ImgErrorHandlerDirective,
    RemoveTextPipe
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    RouterModule,
    PipesCoreModule,
    MatCheckboxModule,
    MatButtonModule,
    MatDialogModule,
    MatButtonModule,
    MatRadioModule,
    MatIconModule,
    MatInputModule,
    MatAutocompleteModule,
    MatTooltipModule,
    MatDividerModule,
    MatSnackBarModule,
    MatRippleModule,
    MatSelectModule,
    MatExpansionModule,
    MatListModule,
    NgxMaskModule.forRoot(optionsMask),
    NgxPayPalModule
  ],
  exports: [CartComponent, SearchModalComponent, PedidoGeneradoComponent],
  providers: [
    SucursalPredeterminadaPipe,
    RouterSolutionsBrandsPipe,
    CalculoKabicoinPipe,
    ProductOrderByPipe,
    CleanClavePipe,
    CalcularPipe,
    EncryptPipe,
    PrecioPipe,
    DatePipe,
    CurrencyPipe,
    BooleanPipe,
    TipoImpuestoPPipe,
    CrearArrayPipe,
    AutocompletePipe
  ],
  entryComponents: [
    FormAddressComponent,
    FormFacturaComponent,
    DialogConfirmComponent,
    PedidoGeneradoComponent
  ]
})
export class CartModule { }
